module.exports = __webpack_public_path__ + "media/images/themes/mandy/4-2f42a0a5427d6d2e155ff24987b68e0f.png";